exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nh1[data-v-26100638] {\n  margin-bottom: 5px !important;\n}\n.cabecalho-conteudo[data-v-26100638] {\n  margin-bottom: 10px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false,"url":true,"alias":{"fonts":"..fonts"}}!./~/vue-loader/lib/style-compiler?{"id":"data-v-26100638","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/CabecalhoDoConteudo.vue
// module id = 995
// module chunks = 1